export class CustomMenuItem {
    id: number;
    selected: boolean = false;
    label: string;
    icon?: string;
	Ionicon?: boolean = false;
    disabled?: boolean = false;
    divider?: boolean = false;
	route?: string;

    constructor(
        id: number,
        selected: boolean,
        label: string,
        icon?: string,
        disabled?: boolean,
        divider?: boolean,
        route?: string,
        Ionicon?: boolean
	) {
        this.id = id;
        this.selected = selected;
        this.label = label;
        this.icon = icon;
        this.disabled = disabled;
        this.divider = divider;
		this.route = route;
		this.Ionicon = Ionicon;
    }
}